import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Wrapper from "../../../../common/component/Wrapper";
import SurchargeInfo from "./SurchargeInfo";
import * as orderActions from "./../../../../../../actions/orderAction";
import { connect, useDispatch } from "react-redux";
import ModalAddSurcharge from "./ModalAddSurcharge";
import { Button } from "antd";
import "./style.less";
import * as Func from "../../../../../../helpers/functions";

function OrderBundleSurcharge(props) {
  const { disableCreated } = props;
  const { t } = useTranslation();
  const [isOpenAddSurcharge, setOpenAddSurcharge] = useState(false);
  const dispatch = useDispatch();
  const { isFetchingBundleSurcharges } = props?.orderState;
  const { order, bundleOrderSurcharge } = props?.orderState?.detail;
  const { getBundleOrderSurcharge } = props;
  const { pageIndex, pageSize, totalCount, result } =
    bundleOrderSurcharge ?? {};

  const loadSurcharge = pageIndex => {
    const params = {
      itemVariantId: order?.id,
      orderId: order?.id,
      pageIndex,
      pageSize,
      totalCount
    };
    getBundleOrderSurcharge(params);
  };

  useEffect(() => {
    loadSurcharge(pageIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const totalPage = useMemo(() => {
    return totalCount % pageSize > 0
      ? totalCount / pageSize + 1
      : totalCount / pageSize;
  }, [totalCount, pageSize]);

  const surchargeTypes = useMemo(() => {
    return [
      { name: t(`item.order.surchargeType.Room`), value: "Room" },
      {
        name: t(`item.order.surchargeType.DepartureFlight`),
        value: "DepartureFlight"
      },
      {
        name: t(`item.order.surchargeType.ReturnFlight`),
        value: "ReturnFlight"
      }
    ];
  }, [t]);

  const removeSurcharge = data => {
    const { pageIndex, pageSize, totalCount } = bundleOrderSurcharge ?? {};
    const { ftCode, id } = data;
    const params = {
      surcharge: {
        id: id,
        orderId: order.id,
        ftCode: ftCode
      },
      pagination: {
        itemVariantId: order?.id,
        orderId: order?.id,
        pageIndex,
        pageSize,
        totalCount
      }
    };
    dispatch(orderActions.bundleOrderCancelSurchargeAction(params));
    closeAddSuchargeModal();
  };

  const onSuchargeSubmit = data => {
    const { pageIndex, pageSize, totalCount } = bundleOrderSurcharge ?? {};
    const {
      cost,
      note,
      ftCode,
      selectedSurcharge: { value: surchargeType }
    } = data;
    const params = {
      surcharge: {
        orderId: order.id,
        itemVariantId: order.id,
        ftCode: ftCode,
        surchargeType: surchargeType,
        Amount: cost,
        Note: note
      },
      pagination: {
        itemVariantId: order?.id,
        orderId: order?.id,
        pageIndex,
        pageSize,
        totalCount
      }
    };
    dispatch(orderActions.bundleOrderCreateSurchargeAction(params));
    closeAddSuchargeModal();
  };
  const openAddSuchargeModal = () => {
    setOpenAddSurcharge(true);
  };
  const closeAddSuchargeModal = () => {
    setOpenAddSurcharge(false);
  };

  const onTableChange = (pagination, filters, sorter) => {
    const { current } = pagination;
    loadSurcharge(current);
  };

  const totalSurcharge = useMemo(() => {
    if (!result || result.length === 0) return 0
    return result.reduce((total, current) => {
      if (current.isDeleted) return total
      return total + current.amount
    }, 0);
  }, [result]);

  return (
    <>
      <Wrapper className="col-md-12 row m-0 p-0 mt-3">
        <Wrapper className={`col-md-10`}>
          <h3>{t("item.order.orderSurcharge")}</h3>
          <span className="bundle-order__total-surcharge">
            {`${t("item.bundleOrderSurcharge.totalSurchargeAmount")}: ${
              Func.formatMoney(totalSurcharge || "") + t("currencySymbol")
            }`}
          </span>
        </Wrapper>
        <Wrapper
          className={`col-md-2 text-align-right bundle-order__btn-create-wrapper`}
        >
          <Button
            disabled={disableCreated}
            className="btn btn-primary ml-3"
            onClick={openAddSuchargeModal}
          >
            {t("item.order.orderCreateSurcharge")}
          </Button>
        </Wrapper>
      </Wrapper>
      <SurchargeInfo
        listType="tours"
        removeSurcharge={removeSurcharge}
        onTableChange={onTableChange}
        surcharges={result || []}
        loading={!!isFetchingBundleSurcharges}
        pagination={{ pageIndex, pageSize, totalCount, totalPage }}
        openModalDetail={() => {}}
        disableCreated={disableCreated}
      />
      <ModalAddSurcharge
        visible={!!isOpenAddSurcharge}
        surchargeTypes={surchargeTypes}
        onSubmit={onSuchargeSubmit}
        onCancel={closeAddSuchargeModal}
      />
    </>
  );
}

const mapStateToProps = state => {
  return {
    orderState: state.orderReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getBundleOrderSurcharge: params =>
      dispatch(orderActions.getBundleOrderSurcharge(params)),
    createSurchargeDetail: surcharge =>
      dispatch(orderActions.createSurchargeDetail(surcharge)),
    updateSurchargeDetail: surcharge =>
      dispatch(orderActions.updateSurchargeDetail(surcharge))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderBundleSurcharge);
